import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { IServicos } from '../models/servicos.model';

@Injectable()
export class ServicoService extends EntityService<IServicos> {
  constructor(protected configService: ConfigService) {
    super(
      {
        baseEntityEndPoint: 'servico',
        urlBackend: configService.backendURL
      }
    );
  }
}
